module.exports = __webpack_public_path__ + "img/edinburgh-rugby-logo-icon.8d080826.png";